module.exports = __webpack_public_path__ + "img/sldb-logo.192e1571.png";